import React, { use, useState } from "react";
import { Check, Lock, CreditCard, Zap } from "lucide-react";
import { showToast } from "../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Col, Row } from "react-bootstrap";
import tick from "../../../assets/img/What You Get tick.svg";
import securePayment from "../../../assets/img/Secure Payment.svg";
import purchase from "../../../assets/img/Purchase credits.svg";
import PremiumRTGClients from "../../../assets/img/Premium RTG Clients.svg";
import StandardClients from "../../../assets/img/Standard Clients.svg";
import { hitGetSettingsApi } from "../../../Redux/Common/GetSettingsSlice";
import {
  ApiBaseUrl,
  createStripeSessionNewProfessional,
} from "../../../Utils/Constants";
import { getProfessionalAuthToken } from "../../../Helper/mobileAuth";

const BuyCredits = () => {
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const [token, setToken] = useState(null);
  const [standardClientBidCost, setStandardClientBidCost] = useState(5);
  const [premiumRTGClientBidCost, setPremiumRTGClientBidCost] = useState(10);
  const [selectedCredits, setSelectedCredits] = useState({
    amount: 25,
    price: 25,
  });
  const [customAmount, setCustomAmount] = useState("");

  useEffect(() => {
    const parsedToken = getProfessionalAuthToken();
    if (!parsedToken) {
      const isProWeb = window.location.pathname.startsWith("/professional");
      navigation(isProWeb ? "/professional/login" : "/get-started", {
        replace: true,
      });
    } else {
      getSettings();
      setToken(parsedToken);
    }
  }, [navigation]);

  const getSettings = async () => {
    try {
      const response = await dispatch(hitGetSettingsApi());
      if (response.payload.status === true) {
        const settings = response.payload.data;
        setStandardClientBidCost(settings.professionalBidNoReadyJobPoints || 5);
        setPremiumRTGClientBidCost(
          settings.professionalBidReadyJobPoints || 10,
        );
      } else {
        showToast("Failed to load settings", "error");
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
      showToast("An error occurred while loading settings", "error");
    }
  };

  const handleCheckout = async () => {
    //console.log("handleCheckout---------", selectedCredits);
    if (parseInt(selectedCredits.amount) < 5) {
      showToast("Minimum purchase is 5 credits", "error");
      return;
    }

    if (!token) {
      const isProWeb = window.location.pathname.startsWith("/professional");
      navigation(isProWeb ? "/professional/login" : "/get-started", {
        replace: true,
      });
      return;
    }

    try {
      const response = await axios.post(
        `${ApiBaseUrl}${createStripeSessionNewProfessional}`,
        {
          amount: selectedCredits.amount * 100,
          currency: "usd",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.data?.status === true && response.data?.data?.url) {
        window.location.href = response.data.data.url;
      } else {
        showToast(
          response.data?.message || "Unable to start checkout. Please try again.",
          "error"
        );
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        // Global axios interceptor: clear storage, toast, redirect to /get-started
        return;
      }
      const message =
        error?.response?.data?.message ||
        "Something went wrong. Please try again.";
      showToast(message, "error");
    }
  };

  const creditOptions = [
    { credits: 10, price: 10, popular: false },
    { credits: 25, price: 25, popular: true },
    { credits: 50, price: 50, popular: false },
    { credits: 100, price: 100, popular: false },
  ];

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const benefits = [
    "Credits never expire while account is active",
    "1 credit = $1.00 (no hidden fees)",
    "Instant credit delivery",
    "Secure payment processing",
  ];

  const handleCustomAmount = (value) => {
    //console.log("Custom amount value:", value);
    setCustomAmount(value);
    if (value) {
      setSelectedCredits({ amount: parseInt(value), price: parseInt(value) });
      return;
    }
    setSelectedCredits({ amount: 0, price: 0 });
  };

  return (
    <div className="purchase-credits pro-app-page manage-dashboard-screen">
      <div
        className="custom_container"
        style={{
          paddingTop: 0,
          marginTop: 0,
          marginBottom: 0,
          boxSizing: "border-box",
        }}
      >
        <h2 style={{ margin: 0, padding: 0 }}>Purchase Bid Credits</h2>
        <p className="subtitle">
          Credits power your bidding on SimpleRenovate. Each credit equals $1.00
          and gives you access to bid on renovation projects.
        </p>

        <div className="purchase-section">
          <Row>
            <Col lg={7}>
              <div className="credit-selection">
                <h3>Select Credit Amount</h3>
                <div className="options">
                  <Row>
                    {creditOptions.map((option) => (
                      <Col md={6} className="mt-3">
                        <div
                          key={option.credits}
                          className={`option-card ${option.popular ? "popular" : ""
                            } ${selectedCredits.amount === option.credits &&
                              !customAmount
                              ? "selected"
                              : ""
                            }`}
                          onClick={() => {
                            setSelectedCredits({
                              amount: option.credits,
                              price: option.price,
                            });
                            setCustomAmount("");
                          }}
                        >
                          <h4>
                            {option.credits} <span>credits</span>
                          </h4>
                          <p>${option.price}</p>
                          {option.popular && (
                            // <div style={{ marginTop: 12, display: 'flex', justifyContent: 'center' }}>
                            <span
                              className="tag"
                              style={{
                                background: "#b22222",
                                color: "#ffffff",
                                fontWeight: 600,
                                borderRadius: 12,
                                padding: "2px 14px",
                                fontSize: 14,
                                boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                              }}
                            >
                              Popular
                            </span>
                            // </div>
                          )}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>

                <div className="custom-input">
                  <label>Or enter custom amount (minimum 5 credits)</label>
                  <input
                    type="number"
                    className="custom-input"
                    placeholder="Enter credit amount"
                    value={customAmount}
                    onChange={(e) => {
                      let value = e.target.value;

                      // Prevent leading zero
                      if (value.length > 1 && value.startsWith("0")) {
                        value = value.replace(/^0+/, "");
                      }
                      handleCustomAmount(value);
                    }}
                    min="0"
                  />
                </div>

                <p className="summary">
                  You’re purchasing{" "}
                  <strong>{customAmount || selectedCredits.amount}</strong>{" "}
                  credits for $
                  <strong>{customAmount || selectedCredits.price}</strong>.00
                </p>
              </div>
            </Col>
            <Col lg={5} className="mt-3 mt-lg-0">
              <div className="what-you-get">
                <div className="what-you-get-header">
                  <h3>What You Get</h3>
                  <ul>
                    <li>
                      <img src={tick} alt="tick" className="me-2" /> Credits
                      expire 1 year after purchase or expire 12 months of
                      inactivity (with no pro subscription, logins, or bids).
                    </li>
                    <li>
                      <img src={tick} alt="tick" className="me-2" /> 1 credit =
                      $1.00 (no hidden fees)
                    </li>
                    <li>
                      <img src={tick} alt="tick" className="me-2" /> Instant
                      credit delivery
                    </li>
                    <li>
                      <img src={tick} alt="tick" className="me-2" /> Secure
                      payment processing
                    </li>
                    <li>
                      <img src={tick} alt="tick" className="me-2" /> Bid on
                      standard jobs ({standardClientBidCost} credits each)
                    </li>
                    <li>
                      <img src={tick} alt="tick" className="me-2" /> Bid on
                      premium RTG jobs ({premiumRTGClientBidCost} credits each)
                    </li>
                  </ul>
                </div>
                <div className="secure-payment">
                  <div>
                    <img src={securePayment} alt="secure payment" />
                  </div>
                  <div>
                    <h4> Secure Payment</h4>
                    <p>
                      Your payment is protected by industry-standard encryption
                      for security and privacy across all transactions.
                    </p>
                  </div>
                </div>

                <button
                  className="purchase-button"
                  onClick={() => {
                    handleViewDetails();
                    handleCheckout();
                  }}
                  disabled={!(customAmount > 0 || selectedCredits.amount > 0)}
                >
                  <img src={purchase} alt="purchase" className="me-2" />{" "}
                  Purchase {customAmount || selectedCredits.amount} Credits – $
                  {customAmount || selectedCredits.price}.00
                </button>
              </div>
            </Col>
          </Row>
        </div>

        <div className="bidding-costs">
          <h3>Bidding Costs</h3>
          <div className="cost-boxes">
            <div className="cost-card">
              <h4>
                <img
                  src={StandardClients}
                  alt="Standard Clients"
                  className="me-2"
                />
                Standard Clients
              </h4>
              <p>
                <strong>{standardClientBidCost} credits</strong>
              </p>
              <span>Entry point for basic leads</span>
            </div>
            <div className="cost-card premium">
              <h4>
                <img
                  src={PremiumRTGClients}
                  alt="Premium RTG Clients"
                  className="me-2"
                />
                Premium RTG Clients
              </h4>
              <p>
                <strong>{premiumRTGClientBidCost} credits</strong>
              </p>
              <span>Higher intent = Serious Customer</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyCredits;
